import React, { useCallback } from 'react'

import { Button } from '@mui/material'
import {
  TableHeader,
  TableRow,
  FormTable,
  TableRowActions,
  TableDialogAction,
  ConfirmationDialog
} from '@front/squirtle'
import { hooks, I18n } from '@front/volcanion'

import Header from './Header'
import Row from './Row'

const SpecificParameterSection = ({ commercial_package_id, record_id, ...props }) => {
  const handleCreate = useCallback(() =>
    window.open(`/specificparameter/create?commercialpackage_id=${commercial_package_id}`, '_blank')
    [commercial_package_id])
  const handleRowClick = useCallback((rowId, row) => window.open(`/specificparameter/${_.get(row, 'specific.specificparameter_id')}`), [])
  const [deleteSpecific] = hooks.useModelFunction('commercialpackagespecificparameters', 'delete')
  return (
    <>
      <Button
        color='primary'
        size='large'
        sx={{ fontSize: 'subtitle.fontSize' }}
        variant='outlined'
        onClick={handleCreate}
      >
        {I18n.t('specificparameter.add', { count: 1 })}
      </Button>
      <ConfirmationDialog name={'specific_delete'} onConfirm={async (state) => { await deleteSpecific({ id: _.get(state, 'row.id') }) }} />
      <FormTable
        model_name={'commercialpackagespecificparameters'}
        config={{
          forced_filter: { commercialpackage: commercial_package_id },
          validate_filter: useCallback(() => !!commercial_package_id, [commercial_package_id]),
          initial_filter: {},
          populate: ['specific', 'commercialpackage']
        }}
        loadOnMount={!!record_id}
        tableProps={{
          enableRowActions: true,
          allowEditMode: false,
          allowRowGenerate: false,
          onRowClick: handleRowClick
        }}
      >
        <TableHeader><Header /></TableHeader>
        <TableRow><Row /></TableRow>

        <TableRowActions>
          <TableDialogAction
            name="specific_delete"
            label={I18n.t('action.delete')}
            getDialogExtra={({ row }) => ({ title: I18n.t('commercialpackage.confirm_delete_specific', { name: _.get(row, 'specific.name') }) })}
          />
        </TableRowActions>
      </FormTable>
    </>
  )
}

export default React.memo(SpecificParameterSection)
